import React, {useEffect} from 'react';
import { Modal } from "@mui/material";
import Fade from '@mui/material/Fade';
import View from '@modul-connect/shared/components/atoms/view'
import { H1, P } from '@modul-connect/shared/components/atoms/text'
import TextField from '@modul-connect/shared/components/molecules/textField'
import Button from '@modul-connect/shared/components/atoms/button';
import modal from '@modul-connect/shared/components/atoms/modal'
import theme from '@modul-connect/shared/theme';

function isNumeric(value) {
  return !Number.isNaN(Number(value));
}

const ModalAddReservation = ({
    openModal,
    onClose,
    addReservation,
    disabled,
    onSubmit
}) => {
    const [providerName, setProviderName] = React.useState('')
    const [fromCode, setFromCode] = React.useState(null)
    const [toCode, setToCode] = React.useState(null)
    const [errorCode, setErrorCode] = React.useState('')
    const [errorProviderName, setErrorProviderName] = React.useState(false)
    const [section, setSection] = React.useState('')
    const [description, setDescription] = React.useState('')

    useEffect(() => {
        if(openModal) {
            setProviderName(null)
            setErrorProviderName(null)
            setDescription(null)
            setSection(null)
            setToCode(null)
            setFromCode(null)
            setErrorCode(null)
        }
    }, [openModal])

    const isName = (name) => {
      if(!name) return false
      if(!name.trim().length) return false
      
      return true
    }

    const onSave = () => {
        let hasErrors = false
        setErrorProviderName(false)
        setErrorCode('')

        if(!isName(providerName)) {
          setErrorProviderName(true)
          hasErrors = true
        }

        if(!fromCode || !toCode) {
          setErrorCode('From and To must have values')
          hasErrors = true
        }

        if(!isNumeric(fromCode) || !isNumeric(toCode)) {
          setErrorCode('From and To must be numeric')
          hasErrors = true
        }

        if(Number(fromCode) > Number(toCode)) {
          setErrorCode('From cannot be greater than To')
          hasErrors = true
        }

        if(hasErrors) {
            return
        }

        const data = {
          fromCode: Number(fromCode),
          toCode: Number(toCode),
          provider: providerName,
          section: section,
          description: description
        }

        addReservation(data)
        onSubmit(data)
        onClose()
    }

    return (
        <Modal
            open={ openModal }
            onClose={(event, reason) => {
              if (disabled && reason === 'backdropClick') {
                return
              }
              onClose()
            }}            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={"Add Reservation"}/>
                        </View>
                        <View extend={{...modal.content, display: 'flex', flexDirection: 'column', gap: '0px', marginTop: '0px', marginBottom: '0px' }}>
                            
                            {/* Row for Inputs */}
                            <View extend={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                                <View extend={{ flex: 1 }}>
                                    <TextField
                                        name="From*"
                                        placeholder="0"
                                        disabled={ disabled }
                                        error={errorCode}
                                        onChange={e => setFromCode(e.target.value)}
                                    />
                                </View>
                                <View extend={{ flex: 1 }}>
                                    <TextField
                                        name="To*"
                                        placeholder="100"
                                        disabled={ disabled }
                                        error={errorCode}
                                        onChange={e => setToCode(e.target.value)}
                                    />
                                </View>
                            </View>

                            { errorCode && (
                                <View extend={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '0px' }}>
                                    <P style={{ color: theme.colors.error, fontSize: '14px', marginTop: '5px', marginBottom: '0px' }}>
                                        { errorCode }
                                    </P>
                                </View>
                            )}
                        </View>
                        <View extend={{ ...modal.content, marginTop: '0'}}>
                            <TextField
                                name="Provider Name*"
                                placeholder="Modul-System HH AB"
                                disabled={ disabled }
                                error={errorProviderName}
                                onChange={e => setProviderName(e.target.value)}
                            />
                            <TextField
                                name="Section"
                                placeholder="Battery"
                                disabled={ disabled }
                                onChange={e => setSection(e.target.value)}
                            />
                            <TextField
                                name="Description"
                                placeholder=""
                                disabled={ disabled }
                                onChange={e => setDescription(e.target.value)}
                            />
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg cancel disabled={ disabled } onClick={ () => onClose() }>
                                Cancel
                            </Button>
                            <Button noBg noPadding disabled={ disabled } onClick={ onSave }>
                                Submit
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalAddReservation;